import { put, select } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';
import { deepCopy } from '../../../utils';
import { actions as invoiceListActions } from './list';

const key = 'INVOICE/DETAIL';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetInvoiceDetail(client, { payload: orderId }) {
  try {
    const invoiceList = yield select((state) => state.invoiceList);
    const { result } = yield client.post('merchant/order/get', {
      data: { orderId },
    });
    // تغییر دیتای داخل لیست کناری بر اساس تغییرات جدید دیتیل مثلا استتوس ریکوعست
    const newInvoiceList = deepCopy(invoiceList.data).map((inv) => {
      if (inv._id === result.order._id) inv = { ...inv, ...result.order };
      return inv;
    });
    yield put(actions.loadSuccess(result.order));
    yield put(invoiceListActions.loadSuccess(newInvoiceList));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
